import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../error.service';
var ErrorInterceptor = /** @class */ (function () {
    function ErrorInterceptor(authenticationService, errorService) {
        this.authenticationService = authenticationService;
        this.errorService = errorService;
    }
    ErrorInterceptor.prototype.intercept = function (httpRequest, next) {
        var _this = this;
        // And handle the error responses if needed
        return next.handle(httpRequest).pipe(catchError(function (err) {
            if (err instanceof HttpErrorResponse) {
                if (err.error != null) {
                    try {
                        var backendError = JSON.parse(err.error);
                        if (backendError['$type'] === 'Symagic.Core.Server.ErrorResponse, Symagic.Core.Server') {
                            switch (backendError['label']) {
                                case 'APP.CORE.UNKNOWN_USER':
                                    _this.errorService.addError(new Error('APP.CORE.UNKNOWN_USER'));
                                    return throwError(err);
                                case 'APP.CORE.SERVER_OVERLOAD':
                                    console.warn('Retrying request');
                                    var retryRequest = httpRequest.clone();
                                    return next.handle(retryRequest);
                                default:
                                    // Let the breeze adapter handle this error.
                                    return throwError(err);
                            }
                        }
                        console.warn("Error not properly handled by backend: " + err.error);
                    }
                    catch (_a) {
                        console.warn("Failed to parse backend error: " + err.error);
                    }
                }
                switch (err.status) {
                    case 401: {
                        _this.errorService.addError(new Error('APP.CORE.NOT_AUTHORIZED'));
                        break;
                    }
                    case 500: {
                        _this.errorService.addError(new Error('APP.CORE.DEFAULT_HTTPERROR'));
                        break;
                    }
                }
                // return the error back to the caller
                return throwError(err);
            }
        }));
    };
    return ErrorInterceptor;
}());
export { ErrorInterceptor };
